import { render, staticRenderFns } from "./ImportsList.vue?vue&type=template&id=6bb356d8&scoped=true&"
import script from "./ImportsList.vue?vue&type=script&lang=js&"
export * from "./ImportsList.vue?vue&type=script&lang=js&"
import style0 from "./ImportsList.vue?vue&type=style&index=0&id=6bb356d8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb356d8",
  null
  
)

export default component.exports